import MAPI_SERVICE_ACTION_RECORD from '@m/apis/action-record/index'

export default {
  namespaced: true,
  state: {
    info: {},
  },
  mutation: {
    SET_WARNIGN_DETAIL_INFO(state, info) {
      state.info = info
    },
  },
  actions: {
    async getWarningDetailInfo({ commit }, payload = {}) {
      const res = await MAPI_SERVICE_ACTION_RECORD.fetchWarnRecordDetails(payload)
    },
  },
}
